import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  report: {},
  formTypes: [],
  companies: [],
  selectedFormType: null,
  
  requesting: true,
  filtersLoading: false,
  submitting: false,
  isSaved: false,

  errors: {}
};

const Slice = createSlice({
  name: '@admin/Report|Form',
  initialState,
  reducers: {
    
    initialState: () => initialState,

    // ----- GET REPORT -----
    getReport: (state) => {
      state.report = {};
      state.requesting = true;
    },
    getReportSuccess: (state, action) => {
      const { payload } = action;
      // Axios interceptor already extracts response.data.data
      state.report = payload || {};
      state.requesting = false;
    },
    getReportFailed: (state, action) => {
      state.errors = action.payload;
      state.requesting = false;
    },

    // ----- GET FILTERS -----
    getFormFilters: (state) => {
      state.filtersLoading = true;
    },
    getFormFiltersSuccess: (state, action) => {
      const { payload } = action;
      state.formTypes = payload.formTypes || [];
      state.companies = payload.companies || [];
      state.filtersLoading = false;
    },
    getFormFiltersFailed: (state, action) => {
      state.errors = action.payload;
      state.filtersLoading = false;
    },

    // ----- GET FORM TYPE -----
    getFormType: (state) => {
      state.selectedFormType = null;
    },
    getFormTypeSuccess: (state, action) => {
      const { payload } = action;
      // Axios interceptor already extracts response.data.data
      // So payload is already the form type object
      state.selectedFormType = payload || null;
    },
    getFormTypeFailed: (state, action) => {
      state.errors = action.payload;
      state.selectedFormType = null;
    },

    // ----- SAVE -----
    saveForm: (state) => {
      state.submitting = true;
      state.isSaved = false;
    },
    saveFormSuccess: (state, action) => {
      const { payload } = action;
      state.report = payload;
      state.submitting = false;
      state.isSaved = true;
    },
    saveFormFailed: (state, action) => {
      state.errors = action.payload;
      state.submitting = false;
      state.isSaved = false;
    },

    // ----- RESET SAVED FLAG -----
    resetSavedFlag: (state) => {
      state.isSaved = false;
    },

  },
});

export const Actions = Slice.actions;

const Reducers = {
  AdminReportFormReducers: Slice.reducer,
}
export default Reducers;
